import { combineReducers } from 'redux'

import homeReducer from '../container/home'
import arbitriReducer from '../container/arbitri'
import sortingReducer from '../container/sorting'
import distinteReducer from '../container/distinte'
import selectionReducer from '../container/selection'
import iscrizioniReducer from '../container/iscrizioni'
import spostamentiReducer from '../container/spostamenti'
import affiliazioniReducer from '../container/affiliazioni'
import designazioneReducer from '../container/designazione'
import iscrizioniCorsiReducer from '../container/iscrizioniCorsi'
import { apiSlice } from '../hooks/api-slice'

export const rootReducers = combineReducers({
  home: homeReducer,
  arbitri: arbitriReducer,
  sorting: sortingReducer,
  distinte: distinteReducer,
  selection: selectionReducer,
  iscrizioni: iscrizioniReducer,
  spostamenti: spostamentiReducer,
  affiliazioni: affiliazioniReducer,
  designazione: designazioneReducer,
  iscrizioniCorsi: iscrizioniCorsiReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
})
